import { useState } from "react";
import { Loader2, XCircle } from "lucide-react";
import { Button } from "./ui/button";

export const CancelBuildButton = ({ onCancel }) => {
  const [cancelling, setCancelling] = useState(false);
  const cancel = async () => {
    setCancelling(true);
    await onCancel?.();
    setCancelling(false);
  };
  return (
    <Button variant="ghost" className="rounded-full h-11 gap-2 text-destructive hover:text-destructive" onClick={cancel} disabled={cancelling} data-testid="build-cancel-btn">
      {cancelling ? <Loader2 className="h-4 w-4 animate-spin" /> : <XCircle className="h-4 w-4" />} Cancel build
    </Button>
  );
};
